import React, { useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Copyright from "../../components/Footer/Copyright";
import TableBackdrop from "../../components/Table/TableBackdrop";
import { useLocation } from "react-router-dom";
import CustomSnackbar from "../../components/Snackbar/Snackbar";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  content: {
    flexGrow: 1,
    height: "100vh",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  copyright: {
    position: "relative",
    bottom: 0,
  },
}));

/**
 * A dashboard component that renders charts depending on the role of the user.
 */
export default function Dashboard() {
  const classes = useStyles();
  const location = useLocation();
  const message = (
    <>
      Şifreniz bilgi güvenliği gereksinimlerini karşılamamaktadır. Lütfen daha
      güçlü bir şifre belirleyiniz.
    </>
  );
  const [snackbar, setSnackbar] = useState(
    !!location.state?.error
  );
  const [snackbarMessage] = useState(location.state?.error ? message : "");
  const [severity] = useState("info");
  const [backdropLoading, setBackdropLoading] = React.useState(false);

  const init = useCallback(async () => {
    setBackdropLoading(true);
    setBackdropLoading(false);
  }, []);
  React.useEffect(() => {
    init();
  }, [init]);

  return (
      <div className={classes.root}>
        <TableBackdrop backdropLoading={backdropLoading} />
        <CssBaseline />
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <CustomSnackbar
                snackbar={snackbar}
                setSnackbar={setSnackbar}
                snackbarMessage={snackbarMessage}
                severity={severity}
            />
          </Container>
          <Box pt={4} className={classes.copyright}>
            <Copyright
                string={"DELTA Smart Technologies"}
                url={"https://deltasmart.tech/en/home/"}
                date={new Date().getFullYear()}
            />
          </Box>
        </main>
      </div>
  );
}
